export const apiurl = 'https://api.udreo.com/';
// https://loademupapi.uberfortruck.com/
// https://apidev.loademup.xyz/

export const pickupicn = './assets/img/pickup.png';
export const dropupicn = './assets/img/drop.png';
export const vehicleicn = './assets/img/vehicle.png';
export const pathicn = './assets/img/driver_accept.png';
export const currenticn = './assets/img/current_location.png';
export const negosicn = './assets/img/negos_marker.png';
export const version = '1.1';
export const awsid = 'AKIAJ3RAXJYDWP7QV3TQ';
export const awskey = 't7r3IruN1YqEIz1uV3CwVDToZGwBptLlNdjft/U3';
export const awsbucket = 'localserviceprocustomer';
export const lang = '0';
export const start_icn = './assets/img/flag.png';
export const start_icn2 = './assets/img/flag2.png';
export const start_icn3 = './assets/img/flag3.png';
export const start_icn4 = './assets/img/flag4.png';
export const start_icn5 = './assets/img/flag5.png';
export const start_icn6 = './assets/img/flag6.png';
export const arrived_icn = './assets/img/arrived_flag.png';
export const reached_icn = './assets/img/reached_destination_flag.png';
export const completed_icn = './assets/img/completed_flat.png';
export const terms_conditin =
  'https://admin.udreo.com/supportText/customer/en_termsAndConditions.php';
export const privacy_policy =
  'https://admin.udreo.com/supportText/customer/en_privacyPolicy.php';
export const appName = 'Udreo';
export const aws = 'https://d13uwl6sgbvjgq.cloudfront.net';

export const MQTT_USERNAME = 'udreoMqtt';
export const MQTT_PASSWORD = 'KHmvk6jSYwfjgKeq7vQA';
export const MQTT_HOST = 'wss://mqtt.udreo.com:2083/mqtt';
export const MQTT_USESSL = true;
export const INVOICE_URL = 'https://invoice.udreo.com/';
export const driver_image =
  'https://res.cloudinary.com/appscripimgs/image/upload/v1575286830/truckr_images/driver_cdb8ug.svg';
export const vehicle_image =
  'https://res.cloudinary.com/appscripimgs/image/upload/v1569062012/truckr_images/truck_czlr4u.svg';
export const enableDimensions = false;
export const year = new Date().getFullYear();
